module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12J7tZN/tc-custom/9781504073349.jpg?1706905938510",
      "alt": "This image is the cover for the book Her Final Victim"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Final Victim\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("With friends like these, who needs enemies? A twisting psychological thriller about what lies behind a marriage’s façade—and the deadly results . . .")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Hazel and Jamie are happily married. Or so it would seem. Behind closed doors, things are far from normal. Jamie has an unhealthy obsession, and Hazel is more worried about herself than her husband."), _c('br'), _c('br'), _vm._v(" So when Millicent injects herself into their lives, with Jamie firmly in her sights, the trio end up on a path that will end in death."), _c('br'), _c('br'), _vm._v(" Everyone has secrets. Everyone has a dark side."), _c('br'), _c('br'), _vm._v(" But who is good, who is bad, and who is going to get away with murder?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      NJ Moss\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0